import { LandingPageContent } from '../types';

const customKidsTShirts: LandingPageContent = {
	path: '/custom-kids-t-shirts',
	seoTitle: 'Custom Kids T-Shirts — Printed With Their Own Character',
	metaDescription:
		"Custom t-shirts for children featuring your child's own illustrated character. Upload a photo, pick a style and size, and we print and ship it.",
	heading: 'Custom Kids T-Shirts',
	subheading: 'Their character, printed on something they can wear out of the house.',
	heroImage: '/assets/hero/kid-1/flat.png',
	intro: `The same illustrated character that appears in a personalized storybook can be printed on a t-shirt.

For children who have aged out of picture books — or who simply want to show the thing off rather than shelve it — this tends to be the better format.`,
	sections: [
		{
			heading: 'How it works',
			body: `Upload a photo and we generate an illustrated version of your child in the art style you pick. That character is then printed on the shirt.

If you have already ordered a personalized book, the avatar is reusable — the shirt will match the character in the book exactly, which children find much more satisfying than two slightly different versions of themselves.

Choose size and colour at checkout.`,
		},
		{
			heading: 'Why this works for older children',
			body: `Around eight, most children start filing picture books under "for little kids". The personalization instinct doesn't go away — the format just has to change.

A t-shirt is public. It gets worn to school, commented on, explained. For a child who likes the attention, it does something a book on a shelf cannot.

It also survives being outgrown well. Parents keep them the way they keep first shoes.`,
		},
		{
			heading: 'Choosing a size',
			body: `Children's sizing varies by manufacturer, so check the size guide on the product page rather than assuming from age alone.

If it's a gift and you're unsure, size up. A slightly large t-shirt gets worn for another year; a slightly small one gets worn twice.`,
		},
		{
			heading: 'Care',
			body: `Wash inside out, cool. Avoid tumble drying the print at high heat and don't iron directly over the design. Printed apparel that's cared for holds its colour through a lot of washes; printed apparel that isn't will fade at the shoulders first.`,
		},
	],
	picks: [
		{
			label: 'Browse apparel and prints',
			href: '/products',
			description: 'T-shirts, hoodies, tote bags and more.',
		},
		{
			label: 'Personalized story books',
			href: '/personalized-story-books',
			description: 'Where the character starts. Best for ages 2–8.',
		},
	],
	faqs: [
		{
			question: 'Can the t-shirt match the character in my personalized book?',
			answer:
				'Yes. Once an avatar has been generated for your child it is saved to your account and can be reused, so the printed character matches across products exactly.',
		},
		{
			question: 'What sizes are available?',
			answer:
				'Available sizes and colours are listed on each product page. Children\u2019s sizing varies between manufacturers, so use the size guide on the listing rather than age alone.',
		},
		{
			question: 'How should I wash a printed t-shirt?',
			answer:
				'Wash inside out on a cool cycle, avoid high-heat tumble drying, and do not iron directly on the print.',
		},
	],
	related: [
		{ label: 'Gifts for kids', href: '/gifts-for-kids' },
		{ label: 'Birthday gifts for kids', href: '/gifts/birthday-gifts-for-kids' },
	],
	cta: { label: 'Design a t-shirt', href: '/products' },
};

export default customKidsTShirts;
